import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Willkommen zurück!");
      nav("/dashboard");
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md">
        <div className="font-display text-xs tracking-[0.3em] text-[#CCFF00] mb-3">
          / TRAINER-LOGIN
        </div>
        <h1 className="font-heading font-black text-4xl leading-tight tracking-tight mb-8">
          Willkommen zurück.
        </h1>
        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <div>
            <label className="font-display text-xs tracking-widest text-white/60 block mb-2">
              E-Mail
            </label>
            <input
              data-testid="login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-[#111214] border border-white/10 rounded-md px-4 py-3 text-white focus:border-[#CCFF00] outline-none transition-colors"
            />
          </div>
          <div>
            <label className="font-display text-xs tracking-widest text-white/60 block mb-2">
              Passwort
            </label>
            <input
              data-testid="login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-[#111214] border border-white/10 rounded-md px-4 py-3 text-white focus:border-[#CCFF00] outline-none transition-colors"
            />
          </div>
          {err && (
            <div data-testid="login-error" className="text-sm text-red-400">
              {err}
            </div>
          )}
          <button
            data-testid="login-submit"
            disabled={loading}
            className="btn-primary w-full justify-center"
          >
            {loading ? "Login läuft …" : "Einloggen"}
          </button>
          <div className="text-right">
            <Link
              to="/forgot-password"
              data-testid="login-forgot-link"
              className="text-xs text-white/60 hover:text-[#CCFF00] transition-colors"
            >
              Passwort vergessen?
            </Link>
          </div>
        </form>
        <div className="mt-6 text-sm text-white/60 text-center">
          Noch kein Konto?{" "}
          <Link to="/register" data-testid="login-goto-register" className="text-[#CCFF00] hover:underline font-semibold">
            Jetzt registrieren
          </Link>
        </div>
        <div className="mt-8 p-4 border border-white/10 rounded-md bg-white/5">
          <div className="font-display text-[10px] tracking-widest text-[#CCFF00] mb-1">
            DEMO-ZUGANG
          </div>
          <div className="text-xs text-white/60">
            E-Mail: trainer@fmp.de · Passwort: fmp2026
          </div>
        </div>
      </div>
    </div>
  );
}
